"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Anchor = void 0;
const tslib_1 = require("tslib");
const styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
exports.Anchor = styled_components_1.default.a `
  margin: 0;
  font-size: ${({ size }) => (size ? size : '15px')};
  color: ${({ color }) => (color ? color : 'black')};
  text-decoration: ${({ decoration }) => (decoration ? decoration : 'none')};
`;
